/**
 * Shared constants for search functionality
 */

/** Minimum characters required to trigger a search */
export const SEARCH_MIN_CHARS = 2

/** Debounce delay in milliseconds for search input */
export const SEARCH_DEBOUNCE_MS = 300

/** Maximum number of user search results to return per protocol */
export const SEARCH_RESULTS_LIMIT = 5

/** Number of post results per page (per protocol) for paginated post search */
export const POST_SEARCH_PAGE_SIZE = 25

/** Number of hashtag results to request for the Hashtags search tab */
export const HASHTAG_SEARCH_LIMIT = 20

/** Number of suggested Mastodon profiles to request for the search empty state */
export const SUGGESTIONS_LIMIT = 6
